import ItemFactory from "../actor/item/ItemFactory";
import Quest from "./Quest";

export default class QuestDefeatBoss extends Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._boss = null;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._boss = metadata.boss;
    }

    /**
     * @returns {string}
     */
    get boss() {
        return this._boss;
    }
}